// extracted by mini-css-extract-plugin
module.exports = {"main":"CVCHealthCardInputStyles_main__1FUV6","healthCardContainer":"CVCHealthCardInputStyles_healthCardContainer__38kwY","hcn":"CVCHealthCardInputStyles_hcn__2a9gl"};